import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';
import { DecimalPipe } from '@angular/common';
import { salesMasterDetDto } from './salesmasterdetdto';

export interface SalesMasterParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface SalesMaster { 

    phBillId?: any;
    indentId:number;
    fullcreditflag:string;
    salesHoldphBillId:any;
    phPaidAmount:number;
    billsettledflag:string;
    phBillNo:any;
    phdoctorid:string;
    phBillDate:any;
    phBillTotal:number;
    phGSTTotal:number;
    phDiscounttype:string;
    phRoundofftpe:string;
    phDiscountpercentage:number;
    phDiscountamount:number;
    phRoundoff:number;
    phNettotal:number;
    phAmountReceived:number;
    phAmountReturned:number;
    phReceiptmode:string;
    phSaleType:string;
    phBillTowhom:string;
    phBillCustomerId:string;
    phBillRegId:string;
    phBillAdmId:number;
    createdBy:any;
    createdDate:any;
    branchId: string;
    tenantId: string;  
    
    //New Column

    updatedBy: any; 
    updatedDate: Date;
    updatedIP: string;  
    createdIP: string;
   
    salesMasterDetDto: salesMasterDetDto[];
    
    parameters?: SalesMasterParameter[];
    links?: any;
}


export abstract class SalesMasterData {
    abstract getall(url: string): Observable<SalesMaster[]>;
    abstract getById(url: string): Observable<any>;
    abstract create(url: string, data: SalesMaster): Observable<SalesMaster[]>;
    abstract update(url: string, data: SalesMaster): Observable<SalesMaster>;
    abstract list(url: string): Observable<any>; 
    abstract searchList(url: string,data:any): Observable<any>;

    //SalesReportForMultiBranch    
    abstract searchForMultiBranch(url: string,data:any): Observable<any>;
}
